import moment from 'moment'

import { createSelector } from 'reselect'

import { 
	getCurrentUser,
	getCurrentAccount
} from 'state/selectors'

export const getLastUnreadItem = (chat, tempUser, entities) => {
	const userId = typeof tempUser == 'number' ? tempUser : tempUser.id

	if(!chat.chat_items || !chat.chat_items.length){
		return
	}

	chat.chat_items.sort((a, b) => {
		return a - b
	})

	const lastChatItem = entities.chat_items[chat.chat_items[(chat.chat_items.length - 1)]]

	if(!lastChatItem || !lastChatItem.object){
		return 
	}

	let lastItem = {
		type: lastChatItem.item_type == 'App\\Message' ? 'message' : 'version',
	}

	const {
		messages: allMessages = {},
		versions: allVersions = {}
	} = entities

	lastItem.item = lastItem.type == 'message' ? allMessages[lastChatItem.object.id] : allVersions[lastChatItem.object.id]

	if(!lastItem || !lastItem.item){
		return null
	}

	if(!lastItem.item.seen_by || lastItem.item.seen_by.indexOf(userId) == -1){
		if(lastItem.item.user_id && lastItem.item.user_id == userId){
			return null
		}else if(lastItem.item.sender_id && lastItem.item.sender_id == userId){
			return null 
		}
		
		return lastItem
	}else{
		return null
	}
}

export const getLastChatItem = (chat, entities) => {
	let lastItem = null

	const {
		messages,
		versions = {},
		chat_items
	} = entities

	if (chat) {
		chat.chat_items.sort((a, b) => {
			return b - a
		})

		chat.chat_items && chat.chat_items.some(chatItemId => {
			const tempChatItem = chat_items[chatItemId]

			if(tempChatItem && tempChatItem.object){
				const tempObject = tempChatItem.item_type == 'App\\Message' ? messages[tempChatItem.object.id] : versions[tempChatItem.object.id]
			
				if(tempObject && !tempObject.deleted_at){
					lastItem = tempObject

					return true
				}
			}
		})

		return lastItem
	}
}

export const getChatObjects = createSelector(
	[
		state => getCurrentUser(state),
		state => getCurrentAccount(state),
		state => state.account.entities
	], (user, account, entities) => {
		let chatIds = []
		let processedChatObjects = []
		let hasUnseenItems = false

		if(user.chats){
			chatIds = [...user.chats]
		}

		account.teams && account.teams.forEach(teamId => {
			const teamObject = entities.teams[teamId]

			if(teamObject && teamObject.chat && teamObject.userIds.indexOf(user.id) !== -1){
				chatIds.push(teamObject.chat)
			}
		})

		chatIds.forEach(chatId => {
			let chatObject = entities.chats[chatId]

			if(chatObject && chatObject.chat_items && chatObject.chat_items.length && !chatObject.is_assistant_chat){
				chatObject.chat_items.sort((a, b) => {
					return b - a
				})

				const lastUnreadItem = getLastUnreadItem(chatObject, user, entities)
				const lastItem = getLastChatItem(chatObject, entities)

				if(lastUnreadItem){
					hasUnseenItems = true
				}

				processedChatObjects.push({
					chatObject,
					lastUnreadItem,
					lastItem
				})
			}
		})

		processedChatObjects = processedChatObjects.sort((a, b) => {
			const aLastItem = getLastChatItem(a.chatObject, entities)
			const bLastItem = getLastChatItem(b.chatObject, entities)

			const aCreatedAt = aLastItem ? aLastItem.created_at : moment().toLocaleString()
			const bCreatedAt = bLastItem ? bLastItem.created_at : moment().toLocaleString()

			return bCreatedAt.localeCompare(aCreatedAt)
		})

		return {
			chats: processedChatObjects,
			hasUnseenItems
		}
	}
)